// pdf.js — single import point for PDF.js with the worker wired up.
// Both invoice-parser.js and doc-provenance.jsx import from here so the
// workerSrc is configured exactly once, and the worker ships in the bundle
// (?url) at the same version as the API — no CDN, covered by CSP
// worker-src 'self'.
import * as pdfjsLib from 'pdfjs-dist';
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

if (typeof window !== 'undefined') {
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
}

export { pdfjsLib };
